import { render, staticRenderFns } from "./outputPage.vue?vue&type=template&id=bc451ff6&"
import script from "./outputPage.vue?vue&type=script&lang=ts&"
export * from "./outputPage.vue?vue&type=script&lang=ts&"
import style0 from "./outputPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports